"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hotlist = void 0;
const HotlistColumn_1 = require("./HotlistColumn");
const HotlistResult_1 = require("./HotlistResult");
const propertyMapping = {
    premarket: 'isPreMarket',
    ranked: 'isRanked',
    hotlist: 'name'
};
class Hotlist {
    constructor(obj) {
        let units, targetProperty;
        for (const prop in obj) {
            switch (prop) {
                case 'columns':
                    this.columns = obj[prop].map((c) => new HotlistColumn_1.HotlistColumn(c));
                    break;
                case 'results':
                    // The HotlistValue requires the `units` property from the HotlistColumns
                    // in order to determine the `HotlistUnit`. For that reason, we are copying
                    // the values of those properties here in the HotlistResults so we can have it handy.
                    units = obj.columns.map((c) => c.units);
                    this.results = obj[prop].map((r) => new HotlistResult_1.HotlistResult(r, units));
                    break;
                case 'timestamp':
                    this.timestamp = new Date(obj[prop]);
                    break;
                default:
                    targetProperty = propertyMapping[prop];
                    this[targetProperty] = obj[prop];
                    break;
            }
        }
    }
}
exports.Hotlist = Hotlist;
//# sourceMappingURL=Hotlist.js.map